<template>
  <div v-if="product.purchaseDate" class="contents">
    <div class="order_info">
      <span class="order_date">
        {{ product.purchaseDate }}
      </span>
      <span class="order_num">
        {{ $t('purchase.order_number') }}: {{ product.purchaseNumber }}
      </span>
    </div>
    <div class="game_name_info">
      <span class="game_name">{{ gameName }}</span>
    </div>

    <div class="purchase_game_info_wrapper">
      <div v-for="purchaseDetail in purchaseDetails" class="purchase_game_info">
        <div class="game_name_box">
          <div class="game_text">{{ purchaseDetail.productName }}</div>
          <div class="game_info_detail">
            <div class="game_info_detail_quantity">
              {{ purchaseDetail.purchaseCount }}개
            </div>
            <div class="game_info_detail_bar"></div>
            <div class="game_info_detail_price">
              {{
                $t('common.unit_with_value.unit_currency', {
                  value: purchaseDetail.purchaseAmount.addComma()
                })
              }}
            </div>
          </div>
        </div>
        <!-- <div
          v-if="purchaseDetail.purchaseFreeAmount"
          class="game_info_detail_mileage"
        >
          <span>({{ purchaseDetail.purchaseFreeAmount.addComma() }}</span>
          <span class="game_info_detail_mileage_name">
            {{ purchaseDetail.coinUnit }}
          </span>
          <span class="game_info_detail_mileage_usage">
            {{ $t('purchase.use') }})
          </span>
        </div> -->
      </div>
    </div>
    <div class="purchase_game_price_info">
      <div class="price_info_detail">
        <div class="price_text">{{ $t('purchase.total_product_amount') }}</div>
        <div class="price_info_detail_price">
          {{
            $t('common.unit_with_value.unit_currency', {
              value: product.purchaseTotalAmount.addComma()
            })
          }}
        </div>
      </div>
      <div class="line"></div>
      <div class="purchase_box">
        <div class="price_info_detail">
          <div class="price_info_title">{{ $t('purchase.payment_date') }}</div>
          <div class="price_info_text">{{ product.purchaseDate }}</div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.payment_number') }}
          </div>
          <div class="price_info_text">{{ product.purchaseNumber }}</div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.payment_status') }}
          </div>
          <div class="price_info_text">{{ convertPurchaseStatus }}</div>
        </div>
        <div v-if="product.purchasePointTotalAmount" class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.playpoint') }}
          </div>
          <div class="price_info_text">
            <span>{{ product.purchasePointTotalAmount.addComma() }}</span>
            <span class="price_info_text">
              P
            </span>
          </div>
        </div>
        <div v-if="product.purchaseFreeTotalAmount" class="price_info_detail">
          <div class="price_info_title">
            <span class="price_info_title">{{ product.coinName }}</span>
            <span class="price_info_title_use">{{ $t('purchase.use') }}</span>
          </div>
          <div class="price_info_text">
            <span>{{ product.purchaseFreeTotalAmount.addComma() }}</span>
            <span class="price_info_text">
              {{ product.coinUnit }}
            </span>
          </div>
        </div>
        <div class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.payment_amount') }}
          </div>
          <div class="price_info_text">
            <span>
              {{
                $t('common.unit_with_value.unit_currency', {
                  value: payAmount.addComma()
                })
              }}
            </span>
            <!-- <span class="price_info_text_user">원</span> -->
          </div>
        </div>
        <div v-if="payAmount !== 0" class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.payment_method') }}
          </div>
          <div class="price_info_text">{{ product.purchaseType }}</div>
        </div>
        <div v-if="product.currency" class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.global_pg_currency') }}
          </div>
          <div class="price_info_text">{{ product.currency }}</div>
        </div>
        <div v-if="product.totalExchangeAmount" class="price_info_detail">
          <div class="price_info_title">
            {{ $t('purchase.global_pg_amount') }}
          </div>
          <div class="price_info_text">
            {{ product.totalExchangeAmount }}
          </div>
        </div>
      </div>
      <div class="gray_line"></div>
      <div v-if="hasRefund" class="refund_box">
        <div class="price_info_detail">
          <div class="price_info_title">{{ $t('purchase.refund_date') }}</div>
          <div class="price_info_text">
            {{ product.refundDateTime }}
          </div>
        </div>
        <div
          v-if="product.refundPointTotalAmount !== 0"
          class="price_info_detail"
        >
          <div class="price_info_title">
            <span class="price_info_title_refund">
              {{ $t('purchase.refund_playpoint') }}
            </span>
          </div>
          <div class="price_info_text">
            <span>
              {{ product.refundPointTotalAmount.addComma() }}
            </span>
            <span class="price_info_text">P</span>
          </div>
        </div>
        <div
          v-if="product.refundFreeTotalAmount !== 0"
          class="price_info_detail"
        >
          <div class="price_info_title">
            <span class="price_info_title_refund">
              {{
                $t('purchase.refund_with_coin', {
                  coin: product.coinName
                })
              }}
            </span>
          </div>
          <div class="price_info_text">
            <span>
              {{ product.refundFreeTotalAmount.addComma() }}
            </span>
            <span class="price_info_text">{{ product.coinUnit }}</span>
          </div>
        </div>
        <div v-if="refundValue > 0" class="price_info_detail">
          <div class="price_info_title">{{ $t('purchase.refund_amount') }}</div>
          <div class="price_info_text">
            <span>
              {{ refundValue.addComma() }}
            </span>
            <span class="price_info_text">
              {{ $t('common.unit.unit_currency') }}
            </span>
          </div>
        </div>
        <div v-if="refundValue > 0" class="price_info_detail">
          <div class="price_info_title">{{ $t('purchase.refund_method') }}</div>
          <div class="price_info_text">{{ product.purchaseType }}</div>
        </div>
      </div>
    </div>
  </div>
  <contents-none
    v-else
    :noneText="$t('purchase.no_purchase_history')"
  ></contents-none>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentsNone from '@/views/base/ContentsNone'

export default {
  name: 'AlltemPurchaseDetail',
  components: {
    ContentsNone
  },
  props: {},
  data() {
    return {
      product: this.$route.params,
      purchaseDetails: this.$route.params.purchaseDetails
    }
  },
  computed: {
    ...mapGetters('main', [
      'enableReward',
      'enableCart',
      'paymentSystemType',
      'name',
      'gameName'
    ]),
    convertPurchaseStatus() {
      switch (this.product.purchaseStatus) {
        case 0:
          return this.$t('status.purchase.rollback')
        case 1:
          return this.$t('status.purchase.request')
        case 2:
          return this.$t('status.purchase.payment_approved')
        case 3:
          return this.$t('status.purchase.normal_purchase')
        case 4:
          return this.$t('status.purchase.refund')
        case 5:
          return this.$t('status.purchase.partial_refund')
        default:
          return this.$t('status.purchase.unknown')
      }
    },
    payAmount() {
      if (this.product.purchaseStatus === 5) {
        return (
          this.product.purchasePaidTotalAmount +
          this.product.purchaseLiabilitiesTotalAmount
        )
      }

      return (
        this.product.purchasePaidTotalAmount +
        this.product.purchaseLiabilitiesTotalAmount
      )
    },
    refundValue() {
      return (
        this.product.refundPaidTotalAmount +
        this.product.refundLiabilitiesTotalAmount
      )
    },
    hasRefund() {
      return (
        this.product.purchaseStatus === 4 || this.product.purchaseStatus === 5
      )
    }
  },
  methods: {},
  mounted() {
    if (
      this.purchaseDetails === undefined ||
      this.purchaseDetails.length === 0
    ) {
      history.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.order_info {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px 10px 16px;
  background-color: white;
  border-bottom: 1px solid #d6d6db;
  font-family: 'Noto Sans KR';
  font-size: 14px;
  .order_date {
    font-weight: bold;
    color: #151721;
  }
  .order_num {
    color: #636376;
  }
}
.game_name_info {
  display: flex;
  font-family: 'Noto Sans KR';
  background-color: white;
  .game_name {
    padding: 10px 0px 0px 16px;
    font-size: 13px;
    font-weight: bold;
    color: #151721;
  }
}
.purchase_game_info_wrapper {
  background-color: white;
  padding-bottom: 12px;
  .purchase_game_info {
    padding: 12px 16px 0 16px;
    font-family: 'Noto Sans KR';
    background-color: white;
    // border-bottom: 1px solid #ededed;

    .game_name_box {
      display: flex;
      justify-content: space-between;
      // margin: 12px 0;
      .game_text {
        font-size: 15px;
        color: #151721;
      }
      .game_info_detail {
        display: flex;
        align-self: center;
        .game_info_detail_quantity {
          font-size: 13px;
          color: #636376;
        }
        .game_info_detail_price {
          font-size: 15px;
          font-weight: bold;
          color: #151721;
        }
        .game_info_detail_bar {
          width: 1px;
          height: 10px;
          margin: 0 6px;
          background-color: #a5a5ac;
        }
      }
    }
    .game_info_detail_mileage {
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      margin: 7px 0;
      .game_info_detail_mileage_name {
        margin-left: 3px;
        font-weight: bold;
      }
      .game_info_detail_mileage_usage {
        margin-left: 3px;
      }
    }
  }
}

.purchase_game_price_info {
  margin-top: 11px;
  padding: 10px 16px;
  font-family: 'Noto Sans KR';
  background-color: white;
  .price_info_detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .price_text {
      font-size: 15px;
      color: #151721;
    }
    .price_info_detail_price {
      font-size: 17px;
      font-weight: bold;
      color: #6134f1;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    margin: 10px 0 16px 0;
    background-color: #636376;
  }
  .gray_line {
    width: 100%;
    height: 1px;
    margin: 16px 0;
    background-color: #d6d6db;
  }
  .price_info_title {
    font-size: 14px;
    color: #636376;
  }
  .price_info_title_bold {
    font-weight: bold;
  }
  .price_info_title_refund {
    margin-right: 3px;
  }
  .price_info_title_use,
  .price_info_text_use {
    margin-left: 3px;
  }
  .price_info_text_use_bold {
    font-weight: bold;
  }
  .price_info_text {
    font-size: 14px;
    color: #151721;
  }
}
</style>
